module.exports = __webpack_public_path__ + "static/media/auth_logo.a84d4fbf.png";